import { render, staticRenderFns } from "./ListKojoHimmoku.vue?vue&type=template&id=210b93f6&scoped=true&"
import script from "./ListKojoHimmoku.vue?vue&type=script&lang=ts&"
export * from "./ListKojoHimmoku.vue?vue&type=script&lang=ts&"
import style0 from "./ListKojoHimmoku.vue?vue&type=style&index=0&id=210b93f6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "210b93f6",
  null
  
)

export default component.exports